<template>
  <com-header>
    <div class="activity">
      <img class="img" :src="banner" alt="">

      <!-- <h1>简单粗暴的优惠模式 参与报名</h1>
      <p class="tips">—— 想<span class="money">省钱</span>还在等什么 ——</p> -->

      <van-form @submit="onSubmit" :style="{background:colorCode}" @failed="onFailed">

        <van-field v-model="formData.name" clearable name="name" placeholder="请输入您的姓名" maxlength="10" :rules="[{ validator:checkName, message: '请输入正确的姓名' }]" />

        <van-field v-model="formData.mobile" type="tel" clearable name="mobile" placeholder="请输入您的手机号" :rules="[{ validator:checkMobile, message: '请输入正确手机号' }]" />

        <van-field v-model="formData.estateName" clearable name="estateName" placeholder="小区名" maxlength="10" />

        <van-field v-model="formData.likeStyleName" is-link readonly name="likeStyleName" placeholder="装修风格" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom" round>
          <van-picker show-toolbar value-key="name" :columns="styleList" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>

        <div class="btn">
          <van-button block native-type="submit" :loading="loading">立即提交</van-button>
        </div>

        <div class="qrcode">
          <p>赶紧扫描下方二维码，获取产品资料</p>
          <p>
            <van-icon name="arrow-down" />
          </p>
          <div class="img-box">
            <img :src="qrcodeImg" alt="">
          </div>
        </div>
      </van-form>

    </div>
  </com-header>
</template>

<script>
import wx from "weixin-js-sdk";
import ComHeader from "./components/comHeader";
import ComCascader from "./components/comCascader";
import {
  AddCustomerInvitation,
  GetActiveInfo,
  GetWxActiveShareAuthInfo,
} from "@/pages/page1/api/modules/user";
import { validMobile, validateZhAndEn } from "@/pages/publicUtils/validate";
import { Form, Field, Button, Toast, Popup, Picker, Icon } from "vant";
export default {
  metaInfo() {
    return { title: this.pageName };
  },
  components: {
    ComHeader,
    ComCascader,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon,
  },
  data() {
    return {
      qrcodeImg: require("@/assets/img/qrcode_wx.jpg"),
      formData: {
        name: "",
        mobile: "",
        estateName: "",
        likeStyle: "",
        likeStyleName: "",
      },
      showPicker: false,
      loading: false,
      banner: "", //require('@/assets/img/activity1.jpg')
      shareMiniImgUrl: "",
      pageName: "活动",
      description: "",
      colorCode: "#ffffff",
      styleList: [],
    };
  },
  mounted() {
    this.getActiveInfo();
  },
  methods: {
    getActiveInfo() {
      GetActiveInfo({ activityInfo: this.$route.params.id }).then((res) => {
        // console.log("获取信息", res);
        this.banner = res.data[0].propagandaFilePath;
        this.shareMiniImgUrl = res.data[0].shareMiniFilePath || "";
        this.pageName = res.data[0].name || "活动";
        this.description = res.data[0].description || "";
        this.colorCode = res.data[0].colorCode;
        this.styleList = res.data[0].styleList;
        this.shareWX();
      });
    },
    shareWX() {
      let shareUrl = process.env.VUE_APP_BASE_URL + this.$route.fullPath; //必须www 和公众号一致
      GetWxActiveShareAuthInfo({ shareUrl }).then((res) => {
        // console.log("获取微信配置", res);
        wx.config({
          debug: false, // 开启调试模式,开发时可以开启
          appId: res.data[0].appId, // 必填，公众号的唯一标识  由接口返回
          timestamp: res.data[0].timestamp, // 必填，生成签名的时间戳 由接口返回
          nonceStr: res.data[0].nonceStr, // 必填，生成签名的随机串 由接口返回
          signature: res.data[0].signature, // 必填，签名 由接口返回
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 此处填你所用到的方法
        });
        let shareData = {
          title: this.pageName, // 分享标题
          desc: this.description, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.shareMiniImgUrl, // 分享图标
        };
        wx.ready(() => {
          // 分享给朋友
          wx.updateAppMessageShareData({
            ...shareData,
            success: function () {
              // console.log("设置成功，而不是分享成功。新接口不支持分享回调");
            },
          });
          // 分享到朋友圈
          wx.updateTimelineShareData({
            ...shareData,
            success: function () {
              // console.log("设置成功，而不是分享成功。新接口不支持分享回调");
            },
          });
        });
      });
    },
    onSubmit(values) {
      this.loading = true;
      // console.log(values);
      let paramsObj = JSON.parse(JSON.stringify(values));
      paramsObj.activityInfo = this.$route.params.id; //邀约人id
      paramsObj.likeStyle = this.formData.likeStyle; //邀约人id
      delete paramsObj.likeStyleName;
      // console.log(paramsObj);
      AddCustomerInvitation(paramsObj)
        .then(() => {
          this.loading = false;
          this.$router.push({
            path: "/examine",
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onFailed({ errors }) {
      // console.log(errors);
      Toast.fail(errors[0].message);
    },
    // 风格
    onConfirm(v) {
      this.formData.likeStyle = v.serNo;
      this.formData.likeStyleName = v.name;
      this.showPicker = false;
    },
    // 验证
    checkMobile(val) {
      return validMobile(val);
    },
    checkName(val) {
      return validateZhAndEn(val);
    },
  },
};
</script>

<style lang="less" scoped>
.activity {
  background-color: #ffffff;
  text-align: center;
  font-size: 0; //图片间隔3px的问题
  .img {
    width: 100%;
    height: auto;
  }
  // h1 {
  //   font-size: 0.5rem;
  //   font-weight: 400;
  //   padding: 0.25rem 0.3rem;
  // }
  // .tips {
  //   opacity: 0.66;
  //   font-size: 14px;
  //   padding: 0 0.3rem 0.23rem;
  //   color: #333333;
  //   .money {
  //     font-size: 20px;
  //   }
  // }
  /deep/ .van-form {
    padding: 0 0.6rem 0.4rem;
    .van-cell.van-field {
      margin-bottom: 0.2rem;
      border-radius: 0.1rem;
      padding: 8px 16px;
      box-shadow: 3px 4px 9px 0px rgba(0, 0, 0, 0.66);
      input::-webkit-input-placeholder {
        color: #b2b2b2;
      }
      input::-moz-input-placeholder {
        color: #b2b2b2;
      }
      input::-ms-input-placeholder {
        color: #b2b2b2;
      }
      .van-field__body {
        .van-field__right-icon {
          -webkit-transform: rotate(90deg);
          -moz-transform: rotate(90deg);
          -o-transform: rotate(90deg);
          -ms-transform: rotate(90deg);
          transform: rotate(90deg);
        }
        .van-field__control {
          .van-stepper {
            width: 100%;
            input {
              width: 100%;
              height: 24px;
              background: #ffffff;
              text-align: left;
            }
          }
        }
      }
      .van-field__error-message {
        display: none;
      }
    }
    .btn {
      margin: 0.3rem 0 0;
      .van-button {
        height: 40px;
        font-size: 16px;
        color: #de231e;
        border-radius: 0.1rem;
        font-weight: bold;
        background: #f8efab;
      }
    }
    .qrcode {
      padding-top: 0.4rem;
      p {
        font-size: 14px;
        color: #f8efab;
        letter-spacing: 2px;
      }
      .img-box {
        margin-top: 2px;
        width: 2rem;
        height: 2rem;
        overflow: hidden;
        border-radius: 8px;
        margin: auto;
      }
    }
  }
}
</style>